/*
 * Project: Dynamedics Survey Platform Web
 * Created Date: Friday March 4th 2022
 * Author: Nalinda Wijayagunawardhane
 * -----
 * Last Modified: Friday March 4th 2022 8:43:26 pm
 * Modified By: Nalinda Wijayagunawardhane at <nwijayagunawardhane@mitrai.com>
 * -----
 * Copyright (c) 2022 Mitra Sparks
 * -----
 * HISTORY:
 */

export const googleAnalyticsConfig = process.env.REACT_APP_GA_MEASUREMENT_ID;
export const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
